import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { App } from './App';
import { initMetaPixel } from './lib/meta-pixel';
import { initGoogleAnalytics } from './lib/google-analytics';
// E2E control bridge (#1286) — side-effect only; no-op in production builds.
import './lib/e2e-bridge';
import './index.css';

// Clean up stale v1 localStorage keys that can crash the v4 app
const V1_KEYS = ['rr-auth-token', 'rr-session-list', 'rr-session-state', 'rr-user-id', 'rr-onboarding-dismissed'];
for (const key of V1_KEYS) {
  localStorage.removeItem(key);
}

async function bootstrap() {
  if (import.meta.env.DEV && !import.meta.env.VITE_DISABLE_MSW) {
    const { worker } = await import('./mocks/browser');
    await worker.start({ onUnhandledRequest: 'bypass' });
  }

  // Load analytics (each a no-op unless its VITE_* id is configured).
  initMetaPixel();
  initGoogleAnalytics();

  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <HelmetProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </HelmetProvider>
    </React.StrictMode>
  );
}

bootstrap();
